import { render, staticRenderFns } from "./CreateTaskPanel.vue?vue&type=template&id=6058ee7a&scoped=true"
import script from "./CreateTaskPanel.vue?vue&type=script&lang=js"
export * from "./CreateTaskPanel.vue?vue&type=script&lang=js"
import style0 from "./CreateTaskPanel.vue?vue&type=style&index=0&id=6058ee7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058ee7a",
  null
  
)

export default component.exports